export default "__VITE_ASSET__771dfb98__"